﻿<script setup lang="ts">
import { computed, onBeforeMount, onBeforeUnmount, onMounted, ref } from 'vue'

const props = withDefaults(defineProps<{ fixed: string, offset: number }>(), { fixed: 'fixed', offset: 0 });

const element = ref<HTMLElement>();
const spacer = ref<HTMLElement>();
const isFixed = ref(false);

const hostNode = computed(() => (element.value?.getRootNode() as ShadowRoot)?.host as HTMLElement);

let styles: CSSStyleDeclaration;
onMounted(() => styles = window.getComputedStyle(element.value!));
onMounted(() => handleScroll());
onBeforeMount(() => window.addEventListener('scroll', handleScroll));
onBeforeUnmount(() => window.removeEventListener('scroll', handleScroll));

function handleScroll() {
  // update base element height:
  spacer.value!.style.height = styles.height;

  // update fixed state:
  var rect = hostNode.value.getBoundingClientRect();
  isFixed.value = rect.top < props.offset;

  Array.from(element.value?.children! as any as HTMLSlotElement[]).forEach((x: HTMLSlotElement) => {
    if (isFixed.value) x.assignedElements()[0]?.classList.add(props.fixed);
    else x.assignedElements()[0]?.classList.remove(props.fixed);
  })
}
</script>

<template>
  <div ref="spacer"></div>
  <div ref="element" class="navbar-sticky" :class="isFixed ? 'fixed' : ''">
    <slot></slot>
  </div>
</template>

<style lang="scss">
:host {
  position: relative;
  display: flex;
}

.navbar-sticky {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;

  &.fixed {
    position: fixed;
  }
}
</style>
